import { Button, InputAdornment, Stack, TextField, Typography } from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next";

import { DropSignedFile } from "../../components";
import { createValidatedFileUpload } from "../../helpers/validatedFileUpload";

import { CertificateMethodState } from "./CertificateMethod";

export type CertificateUploadFormProps = {
  disabled: boolean;
  certFile: CertificateMethodState["certFile"];
  keyFile: CertificateMethodState["keyFile"];
  keyPassword: CertificateMethodState["keyPassword"];
  onCertFile: (file: File) => void;
  onKeyFile: (file: File) => void;
  onKeyPasswordChange: (password: string) => void;
  onConfirm: () => void;
};

export const CertificateUploadForm: React.FC<CertificateUploadFormProps> = ({
  disabled,
  certFile,
  keyFile,
  keyPassword,
  onCertFile,
  onKeyFile,
  onKeyPasswordChange,
  onConfirm,
}) => {
  const { t } = useTranslation();

  const canSubmit = Boolean(certFile && keyFile && keyPassword.trim() !== "") && !disabled;

  return (
    <>
      <Stack>
        <Typography fontWeight={700} variant="caption">
          {t("certificateMethod.certFileHint")}
        </Typography>
        <DropSignedFile
          disabled={disabled}
          selectedFile={certFile}
          acceptedFormats=".crt"
          onFileUpload={createValidatedFileUpload(["crt"], onCertFile, {
            translationKeyPrefix: "certificateMethod",
          })}
        />
      </Stack>
      <Stack>
        <Typography fontWeight={700} variant="caption">
          {t("certificateMethod.keyFileHint")}
        </Typography>
        <DropSignedFile
          disabled={disabled}
          selectedFile={keyFile}
          acceptedFormats=".key"
          onFileUpload={createValidatedFileUpload(["key"], onKeyFile, {
            translationKeyPrefix: "certificateMethod",
          })}
        />
      </Stack>

      <TextField
        disabled={disabled}
        label={t("certificateMethod.keyPassword")}
        variant="outlined"
        type="password"
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => onKeyPasswordChange(e.target.value)}
        autoComplete="off"
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <Button disabled={!canSubmit} onClick={onConfirm} variant="contained">
                  {t("certificateMethod.confirm")}
                </Button>
              </InputAdornment>
            ),
          },
        }}
      />
    </>
  );
};
